var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loginPanel"}},[_vm._v("\n        登录弹窗\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }